import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportcabservice() {



  const cardData = {
"keyword": "Pune Airport Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune Airport Cab Service for travelers seeking safe, timely, and hassle-free airport transfers. Whether you are arriving at Pune Airport, departing for a flight, traveling for business, family trips, late-night arrivals, or early-morning departures, our cab service ensures a smooth and stress-free journey. With experienced drivers who are punctual and well-versed with airport routes and traffic conditions, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience to and from Pune Airport. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, corporate clients, and groups. With 24/7 availability, flight tracking support, doorstep pickup and drop, and easy cab booking, Shivai Travels ensures a comfortable and on-time airport transfer experience.",

"topPlaces": [
  {
    "title": "Pune Airport (Lohegaon Airport)",
    "description":
      "Pune Airport, also known as Lohegaon Airport, is the main domestic and limited international airport serving Pune city. It connects major Indian cities and is a key hub for business and tourism travelers using airport cab services."
  },
  {
    "title": "Viman Nagar",
    "description":
      "Viman Nagar is a prime residential and commercial area located close to Pune Airport. It is known for hotels, shopping malls, restaurants, and corporate offices, making it a frequent pickup and drop location for airport transfers."
  },
  {
    "title": "Kalyani Nagar",
    "description":
      "Kalyani Nagar is a well-developed area near Pune Airport known for luxury hotels, IT offices, cafes, and business hubs. It is a popular destination for corporate airport cab travelers."
  },
  {
    "title": "Yerwada",
    "description":
      "Yerwada is an important locality close to the airport known for government offices, residential zones, and easy connectivity to major parts of Pune city."
  },
  {
    "title": "Koregaon Park",
    "description":
      "Koregaon Park is a premium area in Pune known for hotels, restaurants, nightlife, and international visitors. It is one of the most common airport cab routes due to its popularity among tourists and business travelers."
  },
  {
    "title": "Magarpatta City",
    "description":
      "Magarpatta City is a major IT and residential hub in Pune with many corporate offices and tech parks. It is frequently connected via airport cab services for business travel."
  },
  {
    "title": "Hinjewadi IT Park",
    "description":
      "Hinjewadi IT Park is Pune’s largest IT hub located at a distance from the airport. Airport cab services are widely used by professionals traveling between Hinjewadi and Pune Airport."
  },
  {
    "title": "Shivajinagar",
    "description":
      "Shivajinagar is a central area of Pune with railway connectivity, government offices, and commercial establishments. It is a major pickup and drop zone for airport taxi services."
  },
  {
    "title": "Pune Railway Station",
    "description":
      "Pune Railway Station is a major transportation hub connected to Pune Airport via road. Many travelers use airport cab services for seamless transfers between train and flight journeys."
  },
  {
    "title": "Pune City Airport Route",
    "description":
      "The Pune Airport cab route connects major areas like Viman Nagar, Koregaon Park, Kalyani Nagar, Hinjewadi, and central Pune, ensuring fast and convenient airport transfers across the city."
  }
],



services: [
  {
    name: "Pune Airport Cab",
    description: "Pune airport cab service provides reliable transportation for passengers traveling to and from Pune Airport with comfortable vehicles and experienced drivers. Vehicles are suitable for city and airport travel ensuring smooth and timely journeys for families, tourists, corporate travelers, and local passengers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient airport cab reservations."
  },
  {
    name: "Pune Airport Taxi Service",
    description: "Pune airport taxi service offers dependable transportation for airport transfers with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth city travel suitable for business trips, family travel, tourism, and corporate airport transfers. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Cab to Pune Airport",
    description: "Cab to Pune Airport service provides comfortable transportation for passengers traveling to Pune Airport from different locations across the city. Vehicles ensure reliable city travel with experienced chauffeurs offering safe and smooth airport transfer journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for business travelers, tourists, and family airport travel requirements. Flexible booking options allow convenient airport cab reservations."
  },
  {
    name: "Cab from Pune Airport",
    description: "Cab from Pune Airport service offers reliable transportation with comfortable vehicles and professional drivers for passengers arriving at Pune Airport. Vehicles provide smooth city and outstation travel suitable for tourism, business visits, and family travel. Professional drivers ensure safe driving and timely pickup services from airport terminals. Pickup services are available directly from Pune Airport to homes, hotels, offices, railway stations, and nearby cities. Flexible booking options allow easy airport pickup cab reservations."
  },
  {
    name: "Pune Airport Pickup Drop Cab",
    description: "Pune airport pickup drop cab service provides dependable transportation solutions for airport arrivals and departures across Pune. Vehicles are suitable for local and outstation airport travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, family airport transfers, and tourism trips. Flexible booking options allow convenient pickup and drop cab reservations."
  },
  {
    name: "Airport Transfer Pune Cab",
    description: "Airport transfer Pune cab service provides transparent and reliable transportation for travelers needing comfortable airport transfer services across Pune. Travelers can enjoy smooth journeys with experienced drivers familiar with airport routes and traffic conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport transfer cab reservations."
  },
  {
    name: "24x7 Pune Airport Cab",
    description: "24x7 Pune airport cab service provides economical and round-the-clock transportation for travelers planning airport transfers at any time of the day or night. Comfortable vehicles ensure smooth city travel suitable for business trips, late-night flights, and family airport travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient 24x7 airport cab reservations."
  },
  {
    name: "Best Pune Airport Taxi",
    description: "Best Pune airport taxi service offers convenient transportation for passengers planning comfortable airport travel across Pune. Comfortable vehicles provide smooth city travel with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for local airport transfers, business travel, and tourism visits. Flexible booking options allow premium airport taxi reservations."
  },
  {
    name: "Cheap Pune Airport Cab",
    description: "Cheap Pune airport cab service allows passengers to reserve affordable transportation for airport transfers across Pune. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the airport journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow economical airport cab reservations."
  },
  {
    name: "SUV Pune Airport Taxi",
    description: "SUV Pune airport taxi service provides spacious transportation for families and groups traveling to and from Pune Airport. SUV vehicles offer comfortable seating, luggage capacity, and smooth city performance suitable for family outings and airport travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV airport taxi reservations."
  },
  {
    name: "Innova Pune Airport Cab",
    description: "Innova Pune airport cab service provides premium SUV transportation for passengers seeking comfortable and reliable airport transfer travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, business trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova airport cab reservations."
  },
  {
    name: "Sedan Pune Airport Taxi",
    description: "Sedan Pune airport taxi service offers economical and comfortable transportation for solo travelers, couples, and small families traveling to and from Pune Airport. Sedan vehicles provide smooth city travel with comfortable seating and luggage space suitable for airport transfer journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan airport taxi reservations."
  },
  {
    name: "Pune Airport Booking Cab",
    description: "Pune airport booking cab service offers dependable transportation for passengers planning advance airport travel reservations across Pune. Comfortable vehicles ensure smooth city travel suitable for tourism, corporate travel, and family airport trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient airport booking cab reservations."
  },
  {
    name: "Reliable Pune Airport Cab",
    description: "Reliable Pune airport cab service provides reliable transportation for travelers planning airport pickups and drops with professional drivers and comfortable vehicles. Comfortable vehicles ensure smooth and safe travel suitable for tourists, families, corporate travelers, and airport visitors. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient reliable airport cab reservations."
  },
  {
    name: "Private Pune Airport Transfer",
    description: "Private Pune airport transfer service offers comfortable transportation for passengers looking for exclusive airport travel services across Pune. Vehicles ensure reliable local and airport travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for business executives, families, VIP guests, and private travel requirements. Flexible booking options allow convenient private airport transfer reservations."
  }
],

tableData: [
  ["Pune Airport Cab", "Pune Airport Taxi Service"],
  ["Cab to Pune Airport", "Cab from Pune Airport"],
  ["Pune Airport Pickup Drop Cab", "Airport Transfer Pune Cab"],
  ["24x7 Pune Airport Cab", "Best Pune Airport Taxi"],
  ["Cheap Pune Airport Cab", "SUV Pune Airport Taxi"],
  ["Innova Pune Airport Cab", "Sedan Pune Airport Taxi"],
  ["Pune Airport Booking Cab", "Reliable Pune Airport Cab"],
  ["Private Pune Airport Transfer", "Pune Airport Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Airport Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Airport cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth airport transportation."
      },
      {
        WhyChooseheading: "Affordable Airport Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Airport cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Airport Cab Availability",
        WhyChoosedescription: "Our Pune Airport cab service operates 24 hours a day for airport pickups, airport drops, business travel, family trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Airport Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable airport travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Airport Transfers",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Pune Airport pickup service, airport drop service, one-way airport transfers, round-trip bookings, and customized travel plans."
      },
      {
        WhyChooseheading: "Wide Range of Airport Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and group airport transfers."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, and Pimpri Chinchwad."
      },
      {
        WhyChooseheading: "Experienced Drivers for Airport Transfers",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune Airport routes and traffic conditions, ensuring timely pickups and drops for domestic and international travelers."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Airport cab service?", answer: "Pune Airport cab service provides comfortable taxi transportation for airport pickups, airport drops, and local or outstation travel from Pune Airport." },
    { question: "Is Pune Airport cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune Airport cab service." },
    { question: "Which vehicles are available for Pune Airport transfers?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way airport taxi service?", answer: "Yes, customers can book one-way as well as round-trip Pune Airport taxi services." },
    { question: "Do you provide airport pickup and drop services?", answer: "Yes, Shivai Travels provides both airport pickup and airport drop services across Pune." },
    { question: "Are all Pune Airport taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable airport travel." },
    { question: "Can I book Pune Airport cab service online?", answer: "Yes, customers can easily book Pune Airport cab service online or through phone booking." },
    { question: "Do you provide airport cabs for family and corporate travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family travel and corporate airport transfers." },
    { question: "Are Pune Airport cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune Airport cab service?", answer: "Yes, advance booking is available and recommended for early morning and late night flights." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Patil",
      feedback:
        "Booked Pune Airport cab service with Shivai Travels. On-time pickup, comfortable vehicle, and very professional driver.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Kavita Deshmukh",
      feedback:
        "Excellent Pune Airport taxi service. Affordable pricing, clean cab, and smooth airport transfer experience.",
      rating: 5
    }
  ];











  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-airport-cab.jpg",
  "description": "Book Pune Airport cab service for safe, reliable, and on-time pickup and drop transfers. Shivai Travels offers 24x7 airport taxi service with sedan, SUV, Innova, and luxury cab options for Pune Airport arrivals and departures.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-airport-cab-service"
  }
};



  return (
    <div>

<Helmet>
  <title>Pune Airport Cab Service | Airport Pickup & Drop Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Airport cab service for reliable pickup and drop transfers. 24x7 airport taxi service with sedan, SUV, Innova, and luxury cabs available for Pune Airport travel, arrivals, and departures."
  />

  <meta
    name="keywords"
    content="pune airport cab, pune airport taxi service, cab to pune airport, cab from pune airport, pune airport pickup drop cab, airport transfer pune cab, 24x7 pune airport cab, best pune airport taxi, cheap pune airport cab, suv pune airport taxi, innova pune airport cab, sedan pune airport taxi, pune airport booking cab, reliable pune airport cab, private pune airport transfer"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairportcabservice;